import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import makeAnimated from "react-select/animated";

import MenuList from "./MenuList";

const animatedComponents = makeAnimated();

function CustomFieldDropdown({ label, control, fieldInfo, userFieldErrors, commonInputProps }) {
  const choices = fieldInfo.choices || [];

  return (
    <div data-cy={commonInputProps["data-cy"]}>
      {label}
      <Controller
        name={commonInputProps.name}
        control={control}
        render={({ field: { onChange, value, ref } }) => (
          <Select
            inputRef={ref}
            components={{ MenuList, animatedComponents }}
            isMulti
            options={choices}
            value={choices.filter((c) => value?.includes(c.value))}
            onChange={(val) => onChange(val.map((c) => c.value))}
          />
        )}
      />
      <div className="errorlist" data-cy={`error-${commonInputProps.id}`}>
        {userFieldErrors.map((err, i) => (
          <div key={i}> {err} </div>
        ))}
      </div>
    </div>
  );
}

export default CustomFieldDropdown;
